module.exports = fox._r("images/slideshow_gray.png", __webpack_public_path__ + "images/slideshow_gray.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/slideshow_gray.png
// module id = 1114
// module chunks = 4